export const QUERY = `
query jiraWorkflowProject($cloudId: ID!, $projectIdOrKey: String!) {
  jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectIdOrKey) {
    id
    projectId
		projectType
    projectStyle
    key
    name
		created
    avatar {
      medium
    }
    issueTypes {
      edges {
        node {
          ... on JiraIssueType {
            issueTypeId
            name
            avatar {
              large
            }
            hierarchy {
              level
              name
            }
          }
        }
      }
    }
  }
}`;
